import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "gwiz1",
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("pattern", {
        id: "gwiz_a1",
        patternUnits: "userSpaceOnUse",
        width: "636",
        height: "476.58",
        patternTransform: "scale(0.08) rotate(0)"
      }, [
        _createElementVNode("rect", {
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          fill: "transparent"
        }),
        _createElementVNode("path", {
          d: "M257.674 8.91162L220.422 113.784L184.132 13.2131C175.83 13.4667 167.531 13.6174 158.926 13.6174C150.474 13.6174 142.172 13.4643 133.873 13.3638L97.4297 113.832L60.0775 8.80875C38.0101 6.63168 17.8161 3.69623 0 0.0526327L94.6976 236.066C95.3555 235.915 95.9129 235.915 96.3172 235.915C100.619 228.678 145.057 146.835 145.057 146.835L145.311 146.024C146.627 144.962 148.246 144 150.119 143.189C160.141 139.038 160.849 137.976 153.309 139.038C150.88 139.442 148.5 140.253 146.323 141.469L154.775 107.305L133.669 68.4843L188.18 111.861C188.18 111.861 186.56 134.636 190.611 134.636C194.357 134.636 192.634 144.808 192.331 150.024C191.015 149.213 189.242 148.304 187.522 146.935C185.244 145.062 184.182 143.189 183.775 142.227C184.18 143.696 185.091 146.631 186.457 149.213C187.773 151.641 191.67 154.83 193.544 156.45C196.632 166.471 204.678 189.247 212.168 210.152C211.106 209.494 209.74 208.683 208.271 208.025C200.881 204.278 186.051 190.613 184.18 188.893C188.888 196.283 190.455 198.914 195.163 203.874C199.06 208.175 210.448 216.731 215.915 220.728C215.915 220.728 215.915 220.728 216.065 220.879C218.343 227.154 220.47 233.178 222.341 238.291L318 0C300.138 3.69623 279.942 6.63168 257.674 8.91162Z",
          fill: "transparent",
          "stroke-width": "8",
          stroke: "currentColor"
        })
      ])
    ], -1),
    _createElementVNode("rect", {
      width: "800%",
      height: "800%",
      transform: "translate(0,0)",
      fill: "url(#gwiz_a1)"
    }, null, -1)
  ])))
}
export default { render: render }